import { render } from "./FishHud.vue?vue&type=template&id=796f2fcd&scoped=true"
import script from "./FishHud.vue?vue&type=script&lang=js"
export * from "./FishHud.vue?vue&type=script&lang=js"

import "./FishHud.vue?vue&type=style&index=0&id=796f2fcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796f2fcd"]])

export default __exports__